/**
 * Canada Map Configuration Overrides
 * Sets the correct container div and disables popups/URLs
 */

// Override main settings
simplemaps_canadamap_mapdata.main_settings.div = "canadamap";
simplemaps_canadamap_mapdata.main_settings.auto_load = "no"; // Load on tab switch
simplemaps_canadamap_mapdata.main_settings.popups = "off";
simplemaps_canadamap_mapdata.main_settings.state_url = "";

// Brand colors
simplemaps_canadamap_mapdata.main_settings.background_color = MAP_COLORS.background;
simplemaps_canadamap_mapdata.main_settings.background_transparent = "no";
simplemaps_canadamap_mapdata.main_settings.state_color = MAP_COLORS.stoneDefault;
simplemaps_canadamap_mapdata.main_settings.state_hover_color = MAP_COLORS.goldHover;
simplemaps_canadamap_mapdata.main_settings.border_color = MAP_COLORS.border;
simplemaps_canadamap_mapdata.main_settings.label_color = MAP_COLORS.label;
simplemaps_canadamap_mapdata.main_settings.label_hover_color = MAP_COLORS.labelHover;
simplemaps_canadamap_mapdata.main_settings.label_size = 18;
simplemaps_canadamap_mapdata.main_settings.all_locations_hidden = "yes";  // Hide location markers
simplemaps_canadamap_mapdata.main_settings.keyboard_navigation = "no";  // Disable keyboard navigation (using Jump To dropdown)

// Zoom settings
simplemaps_canadamap_mapdata.main_settings.initial_zoom = -1;  // Fit to container
simplemaps_canadamap_mapdata.main_settings.manual_zoom = "no";  // Disable manual zoom

// Set all provinces to have no URL
for (var province in simplemaps_canadamap_mapdata.state_specific) {
  simplemaps_canadamap_mapdata.state_specific[province].url = "";
}
